import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.scss';

import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

function Login({ signOut, user }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/product'); // Redirect to ProductHome if already logged in
    }
  }, [user, navigate]);

  const handleSignOut = async () => {
    await signOut(); // Sign out the user
    navigate('/login'); // Navigate to the login page
  };

  return (
    <>
      <button onClick={handleSignOut}>Sign out</button>
    </>
  );
}

export default withAuthenticator(Login, { hideSignUp: true});